<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.detailsInfo }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.details }}
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Naslov
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naslov"
                        v-model="complaint.title"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Naziv artikla
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv artikla"
                        v-model="complaint.articleTitle"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Dodijeli artikal
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="complaint.articleId"
                        loadingText="Učitavanje..."
                        noResultsText="Nema rezultata"
                        searchPromptText="Unesite naziv rtikla"
                        :load-options="loadArticles"
                        :async="true"
                        :options="articles"
                        placeholder="Izaberite artikal"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Sifra artikla
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Sifra artikla"
                        v-model="complaint.articleCode"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Serijski broj artikla
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Serijski broj artikla"
                        v-model="complaint.articleSerialNumber"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Broj racuna
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Broj racuna"
                        v-model="complaint.billNumber"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Kontakt osoba
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Kontakt osoba"
                        v-model="complaint.contactPerson"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Status problema</label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="complaint.problemStatus"
                      >
                        <option
                          :value="item.id"
                          :key="item.id"
                          v-for="item in problemStatuses"
                        >{{ item.title }}</option>
                      </select>

                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Tip problema</label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="complaint.problemType"
                      >
                        <option
                          :value="item.id"
                          :key="item.id"
                          v-for="item in problemTypes"
                        >{{ item.title }}</option>
                      </select>

                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      Opis
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Opis"
                        v-model="complaint.description"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      Kratak opis
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Kratak opis"
                        v-model="complaint.shortDescription"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      Komentar
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Komentar"
                        v-model="complaint.comment"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Garancija
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <span
                        class="badge"
                        :class="{
                          'bg-success': complaint.hasWaranty,
                          'bg-warning text-dark': !complaint.hasWaranty,
                        }"
                      >
                        {{ complaint.hasWaranty ? 'Da' : 'Ne' }}
                      </span>
                    </div>
                  </div>


                  <div class="form-group row align-items-center mb-3" v-if="complaint.imageUrl">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Slika
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="popup-gallery row">
                        <div
                          class="img-fluid"
                        >
                          <vue-photo-zoom-pro :high-url="`${baseUrl}${complaint.imageUrl}`">
                            <img
                              class="img-thumbnail"
                              :src="`${baseUrl}${complaint.imageUrl}`"
                            />
                          </vue-photo-zoom-pro>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link
            exact
            :to="{ name: 'RMA' }"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header">
          <strong>{{ translations.deleteBrand }}</strong>
        </h5>
        <div slot="body">
          <span v-html="modalText"> </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="deleteComplaint"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import VuePhotoZoomPro from 'vue-photo-zoom-pro';
import 'vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css';

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import { translations } from '@/mixins';
import helpers from '@/services/helpers';
import api from '@/services/api';
import config from '@/config';
import Modal from '../shared/modal/Modal.vue';

export default {
  name: 'EditComplaint',
  components: {
    VuePhotoZoomPro,
    Treeselect,
    Modal
  },
  mixins: [translations],
  computed: {
    articles() {
      return this.$store.getters.getArticles.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
    },
    problemStatuses() {
      return helpers.getProblemStatusesAsArray();
    },
    problemTypes() {
      return helpers.getProblemTyles();
    },
    modalText() {
      return this.translations.areYouSureBrand.replace(
        '{brand}',
        `<strong>${this.complaint.title}</strong>`
      );
    },
    complaint() {
      return this.$store.getters.getComplaint;
    },
    baseUrl() {
      return config.baseUrl;
    }
  },
  mounted() {
    this.$store.dispatch('getComplaint', this.$route.params.id);
  },
  methods: {
    submitForm() {
      const { complaint } = this;

      api
        .updateComplaint(complaint)
        .then(response => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'RMA' });
        })
        .catch(err => {
          this.$toast.error(err.response.data.info);
        });
    },
    deleteComplaint() {
      api
        .deleteComplaints([this.complaint.id])
        .then(response => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'RMA' });
        })
        .catch(err => {
          this.$toast.error(err.response.data.info);
          this.$router.push({ name: 'RMA' });
        });
    },
    loadArticles({ callback, searchQuery }) {
      this.$store
        .dispatch("getArticles", {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: "title",
        })
        .then(() => {
          callback(null, this.articles);
        });
    },
  }
};
</script>
